import React from 'react';

import {capitalizeEveryWord} from '../../lib/StringUtils';

import CreditCard from '../../images/icons/credit-card.svg';
import BankAccount from '../../images/icons/bank.svg';

const PaymentDisplay = ({ payment }) => {
  if (!payment) return <div className="payment-display">No payment information</div>;
  if (payment.card) {
    let type = payment.card.type;
    let typeIcon = null;
    switch(type) {
      case 'CREDIT_CARD':
      case 'PREPAID_CARD':
      case 'DEBIT_CARD':
        typeIcon = <img src={CreditCard} role="presentation" />;
        type = 'Credit Card';
        break;
      default:
        break;
    }

    return (
      <div className="payment-display">
        <div className="type-line">
          {typeIcon}
          <span>{type}</span>
        </div>
        <div>{capitalizeEveryWord(payment.card.brand.replace(/_/g, ''))} **** **** **** {payment.card.last_four}</div>
        <div>Exp: {payment.card.expiration.month}/{payment.card.expiration.year}</div>
      </div>
    );
  }

  if (payment.bank_account) {
    let typeIcon = <img src={BankAccount} role="presentation" />;
    return (
      <div className="payment-display">
        <div className="type-line">
          {typeIcon}
          <span>{payment.bank_account.name}</span>
        </div>
      </div>
    );
  }

  return <div/>;
};

export default PaymentDisplay;



/** WEBPACK FOOTER **
 ** ./src/views/checkout/PaymentDisplay.js
 **/